define(function(t,i){"use strict";function e(t){this.data=[],this.widget=t}e.$inject=["lpWidget"],i.WidgetModel=e});


// WEBPACK FOOTER //
// ./src/widget-hdfc-broker-services/scripts/models.js